<template>
  <div class='bottom_menu'>
    <div class="menu_item" :class="{ 'on': tabNumber == 1 }" @click="$router.push('/')">
      <img :src="require(`../assets/img/${device}/${region}/bottommenu/home${tabNumber == 1 ? '_on' : ''}.png`)" alt="">
      <span>{{ $t('home') }}</span>
    </div>
    <div class="menu_item" :class="{ 'on': tabNumber == 2 }" @click="$router.push('/gift')">
      <img :src="require(`../assets/img/${device}/${region}/bottommenu/gift${tabNumber == 2 ? '_on' : ''}.png`)" alt="">
      <span>{{ $t('gift') }}</span>
    </div>
    <!-- <div class="menu_item coupon_btn" @click="$router.push('/coupon')">
      <img :src="require(`../assets/img/${device}/${region}/bottommenu/coupon${tabNumber == 5 ? '_on' : ''}.png`)"
        alt="">
      <span v-if="tabNumber != 5">{{ $t('coupon') }}</span>
    </div> -->
    <div class="menu_item" :class="{ 'on': tabNumber == 3 }" @click="$router.push('/integral')">
      <img :src="require(`../assets/img/${device}/${region}/bottommenu/integral${tabNumber == 3 ? '_on' : ''}.png`)"
        alt="">
      <span>{{ $t('integral') }}</span>
    </div>
    <div class="menu_item" :class="{ 'on': tabNumber == 4 }" @click="$router.push('/my')">
      <img :src="require(`../assets/img/${device}/${region}/bottommenu/my${tabNumber == 4 ? '_on' : ''}.png`)" alt="">
      <span>{{ $t('my') }}</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  components: {},
  data() {
    return {

    };
  },
  computed: {
    ...mapState(['region', 'device']),
    tabNumber() {
      switch (this.$route.path) {
        case '/':
          return 1
        case '/gift':
          return 2
        case '/coupon':
          return 5
        case '/integral':
          return 3
        case '/my':
          return 4
      }
    }
  },
  watch: {},
  methods: {

  },
  created() {

  },
  mounted() {

  },
}
</script>
<style lang='less' scoped>
.bottom_menu {
  position: fixed;
  bottom: 0;
  width: 7.5rem;
  height: 1.12rem;
  background: #FFFFFF;
  box-shadow: 0 0.2rem 0.5rem .1rem rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: space-around;

  .menu_item {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;

    img {
      width: .33rem;
      height: .33rem;
    }

    span {
      font-weight: bold;
      font-size: .22rem;
      color: @theme-default-black;
      margin-top: .08rem;
    }
  }

  .menu_item.on {
    span {
      color: @theme-default-pink;
    }
  }

  .coupon_btn {
    transform: translateY(-.07rem);
    position: relative;

    img {
      width: 1.36rem;
      height: 1.36rem;
    }

    span {
      font-weight: bold;
      font-size: .22rem;
      color: #FFFFFF;
      position: absolute;
      bottom: .37rem;
    }
  }
}
</style>
